module.exports = __webpack_public_path__ + "media/images/logo/fliist-b72d4eda90cedbc9209cfa5c290ab797.svg";